// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"MessageSettings_wrapperComponent__gRoqu","notifications":"MessageSettings_notifications__-q3fL","notification":"MessageSettings_notification__yH1Yf"};